import React, { useContext } from 'react';
import { Empty } from 'antd';

import CvePanel from '@totem/components/software/cves/cvePanel';
import CvesContext from '@totem/components/software/cves/cvesContext';
import { isNotNull, isNull } from '@totem/utilities/common';
const CveList = () => {
  const { data, loading } = useContext(CvesContext);

  return (
    <>
      {loading === false && (isNull(data) || data.length === 0) && (
        <Empty description={'CVE details not available'} />
      )}
      {isNotNull(data) &&
        data.map((cve) => <CvePanel key={cve.id} cve={cve} />)}
    </>
  );
};

export default CveList;
